import React, { useEffect, useState } from "react";
import useTrafficPayment from "../../views/payment/useTrafficPayment";
import useCivilEFilePayment from"../../views/civil/new-case/e-file-payment/useCivilEFilePayment"

type FetchProps = {
  url?: string;
  children: (response: any) => React.ReactElement<any>;
  amount: number;
  paymentType?: string;
  TSPAccepted?: boolean;
};

export const Fetch: React.FC<FetchProps> = (props) => {
  const civilPayment = useCivilEFilePayment();
  const trafficPayment = useTrafficPayment();
  const { res } = props?.paymentType == "civil" ? civilPayment : trafficPayment;

  useEffect(() => { 
    const fetchData = async () => {
      const data =
      props?.paymentType == "civil" ?
          await civilPayment.handleMakePayment(props.amount) :
          await trafficPayment.handleMakePayment(props.amount, props?.TSPAccepted);
    };
    fetchData();
  }, [props.amount]);


  return res ? props.children(res) : null;
};

export default Fetch;
